import { Locale } from "./copy";

const explanations: Record<string, { en: string; es: string }> = {
  published_session_not_closed: {
    en: "A published session has not been ended and synchronized by its assigned controller. End that session on that controller, let it synchronize, then refresh eligibility here. Closing the controller application does not end a session.",
    es: "Una sesión publicada no ha sido finalizada y sincronizada por su controlador asignado. Finalice la sesión en ese controlador, sincronice y actualice aquí. Cerrar la aplicación no finaliza la sesión.",
  },
  signed_package_unexpired: {
    en: "A signed session package is still valid for offline use. Wait for it to expire, then refresh eligibility. Ending a session alone does not expire that package.",
    es: "Un paquete firmado sigue vigente para uso sin conexión. Espere a que venza y actualice. Finalizar la sesión no vence ese paquete.",
  },
  signed_lease_unexpired: {
    en: "A POS card allocation is still valid for offline sales. Wait for its expiry and synchronize the POS, then refresh eligibility.",
    es: "Una asignación de cartones sigue vigente para ventas sin conexión. Espere a que venza, sincronice el POS y actualice.",
  },
  protected_non_test_designation: {
    en: "This content, or a linked session, was designated as non-test content. Permanent test deletion is not allowed, including for the owner. Use Archive / restore sessions to remove eligible sessions from the working list while retaining history.",
    es: "Este contenido o una sesión vinculada fue designado como no-prueba. Ni el propietario puede eliminarlo como prueba. Use Archivar / restaurar sesiones para conservar el historial.",
  },
  financial_or_prize_history_protected: {
    en: "Recorded sales, wallets, or prize history must be retained. Use Archive / restore sessions instead of permanent deletion, even if the session was labeled as a test.",
    es: "Se deben conservar ventas, monederos o premios registrados. Use Archivar / restaurar sesiones, incluso si la sesión fue marcada como prueba.",
  },
  mixed_or_unclassified_session_content: {
    en: "Some records also refer to another session. Deletion is blocked to avoid removing unrelated history. This needs a dependency review; typing a name cannot override it.",
    es: "Hay registros vinculados a otra sesión. Se requiere revisar las dependencias para no eliminar historial ajeno. Escribir el nombre no anula esta protección.",
  },
};

export function deletionBlockerMessage(code: string, locale: Locale): string {
  return explanations[code]?.[locale] ?? (locale === "es"
    ? `La eliminación requiere revisión. Código: ${code}. Actualice o comunique este código al soporte.`
    : `Deletion needs review. Code: ${code}. Refresh eligibility or report this code to support.`);
}

export function canConfirmDeletion(names: { en: string; es: string }, confirmation: string,
  attested: boolean, blockers: string[], busy: boolean): boolean {
  return !busy && attested && blockers.length === 0 && confirmation.length > 0
    && Object.values(names).includes(confirmation);
}
